// 요청 아이템 버튼 컴포넌트
import { Check } from 'lucide-react';
import type { RequestItem, WaiterRequestTranslations } from './types';

interface RequestItemButtonProps {
  item: RequestItem;
  isSelected: boolean;
  translations: WaiterRequestTranslations;
  onToggle: (itemId: string) => void;
  selectionId?: string;
  label?: string;
  emoji?: string | null;
}

export function RequestItemButton({
  item,
  isSelected,
  translations,
  onToggle,
  selectionId,
  label,
  emoji,
}: RequestItemButtonProps) {
  const effectiveSelectionId = selectionId ?? item.id;
  const effectiveLabel = label ?? translations.items[item.labelKey as keyof typeof translations.items];

  return (
    <button
      type="button"
      onClick={() => onToggle(effectiveSelectionId)}
      className={`
        relative h-[72px] p-2 rounded-xl border transition-all duration-200
        flex flex-col items-center justify-center gap-1
        ${
          isSelected
            ? 'border-primary bg-primary/5'
            : 'border-border hover:border-primary/30'
        }
      `}
    >
      <div
        className={`
        flex h-8 w-8 items-center justify-center rounded-lg transition-colors
        ${
          isSelected
            ? 'bg-primary/10 text-primary'
            : 'bg-transparent text-muted-foreground'
        }
      `}
      >
        {emoji ? <span className="text-2xl leading-none" aria-hidden="true">{emoji}</span> : item.icon}
      </div>
      <span
        className={`
        text-center text-[11px] font-medium leading-tight
        ${isSelected ? 'text-primary' : 'text-foreground'}
      `}
      >
        {effectiveLabel}
      </span>
      {isSelected && (
        <div className="absolute top-1 right-1 p-0.5 rounded-full bg-primary">
          <Check className="h-2.5 w-2.5 text-white" />
        </div>
      )}
    </button>
  );
}
